import { connect } from 'react-redux';

const mapStateToProps = ({ SignatureData }) => ({ SignatureData });

export default (WrappedComponent) => connect(mapStateToProps, {})(WrappedComponent);
